import { IconNames } from "../../../Foundation/Icons";
import { IconColours } from "../../../Foundation/Icons/interface";
import Button from "../../Button";
import { ButtonTypes, ButtonShapes } from "../../Button/interface";
import { NavButtonProps } from "../interface";

const NavButton = ({
    label,
    onClick,
    size = "24",
    variant = "filled",
    orientation = "",
    theme = "",
    type = ButtonTypes.LabelledIconButton,
    shape = ButtonShapes.TextButtonRect,
    name = IconNames.Add,
    iconColour = IconColours.black,
    ariaPressed = false,
}: NavButtonProps) => {
    const LabelledIconButton = () => (
        <Button
            type={ButtonTypes.LabelledIconButton}
            name={name}
            label={label}
            onClick={() => onClick()}
            size={size}
            orientation={orientation}
            theme={theme}
            iconColour={iconColour}
        />
    );

    const TextButton = () => (
        <Button
            type={ButtonTypes.TextButton}
            shape={shape}
            label={label}
            onClick={() => onClick()}
            variant={variant as "filled" | "outlined"}
            ariaPressed={ariaPressed}
        />
    );

    return type === ButtonTypes.LabelledIconButton ? (
        <LabelledIconButton />
    ) : (
        <TextButton />
    );
};

export default NavButton;
